import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import themeReducer from './themeSlice';
import erpContextReducer from './erpContextSlice';
import sessionReducer from './sessionSlice';
// ── Clean Storage Policy ───────────────────────────────────────────────────────
// Changed based on Dinisuru's request: localStorage is kept clean.
// Auth tokens, user profiles, operating sessions, and remembered company codes are
// NEVER stored in localStorage. State lives exclusively in browser memory (Redux)
// and is rehydrated on page reload or new tab via the HttpOnly cookie silent refresh pattern.

// Wipe any legacy items from localStorage from previous implementations
try {
  localStorage.removeItem('myledger_auth');
  localStorage.removeItem('myledger_session');
  localStorage.removeItem('myledger_last_company_code');
} catch {
  // Silently ignore (e.g. private-browsing / disabled storage)
}

// ── Store ─────────────────────────────────────────────────────────────────────

export const store = configureStore({
  reducer: {
    auth:       authReducer,
    theme:      themeReducer,
    erpContext: erpContextReducer,
    session:    sessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
